import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import { AddCircleOutline, Inventory } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { getData } from "../../../../../../services/library";
import GestionarTalles from "../../../../../stock_almacen/empleados/GestionarTalles";
import { useLegajosContext } from "../../../../context/LegajoTabsContext";

export default function InventarioForm() {
  const [inventario, setInventario] = useState([]);
  const [showModalSizes, setShowModalSizes] = useState(false);
  const { formData } = useLegajosContext();
  const { cuil, nro_legajo, apellido, nombre } = formData.datosPersonales;
  useEffect(() => {
    getData(`/test/getPrestamos/${cuil}`, setInventario);
  }, [cuil]);

  return (
    <Box >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography
          variant="h6"
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <Inventory /> Control de Inventario y Equipo
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddCircleOutline />}
          onClick={() => setShowModalSizes(true)}
          disabled={!formData?.datosPersonales?.cuil}
        >
          Asignar Talles
        </Button>
      </Box>

      <TableContainer
        component={Paper}
        elevation={0}
        sx={{ border: "1px solid #eee" }}
      >
        <Table sx={{ minWidth: 650 }}>
          <TableHead sx={{ bgcolor: "rgba(0,0,0,0.02)" }}>
            <TableRow>
              <TableCell>Artículo / Equipo</TableCell>
              <TableCell>Talle / Medida</TableCell>
              <TableCell>Fecha Entrega</TableCell>
              <TableCell>Estado</TableCell>
              <TableCell>Cantidad</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {inventario?.data?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                  <Typography variant="body2" color="text.secondary">
                    No se han registrado entregas de equipo para este empleado.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              inventario?.data?.prestamos?.map((row) => (
                <TableRow key={row.id}>
                  <TableCell fontWeight="medium">{row.fullName}</TableCell>
                  <TableCell>{row.talle}</TableCell>
                  <TableCell>{row.fechaPrestamo}</TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: "inline-block",
                        px: 1.5,
                        py: 0.5,
                        bgcolor: "success.lighter",
                        color: "success.main",
                        borderRadius: 1,
                        fontSize: "0.875rem",
                        fontWeight: 500,
                      }}
                    >
                      Entregado
                    </Box>
                  </TableCell>{" "}
                  <TableCell>{row.cantidad}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {/* 
      <Box
        sx={{
          mt: 3,
          p: 2,
          bgcolor: "info.lighter",
          borderRadius: 1,
          border: "1px solid #00bcd433",
        }}
      >
        <Typography variant="caption" color="info.main">
          * El módulo de inventario está en fase de desarrollo. Próximamente
          podrá gestionar entregas y devoluciones directamente desde aquí.
        </Typography>
      </Box> */}
      <GestionarTalles
        open={showModalSizes}
        onClose={() => setShowModalSizes(false)}
        empleado={{
          cuil: cuil,
          nombre: nombre,
          apellido: apellido,
          nro_legajo: nro_legajo,
        }}
      />
    </Box>
  );
}
